import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FeatureComponent } from 'src/app/shared/components/feature/feature.component';
import { IntroContainerComponent } from 'src/app/shared/components/intro-container/intro-container.component';
import { SectionSubstitleComponent } from 'src/app/shared/components/section-subtitle/section-subtitle.component';
import { SectionComponent } from 'src/app/shared/components/section/section.component';
import { SubsectionComponent } from 'src/app/shared/components/subsection/subsection.component';

@Component({
  selector: 'app-flipper-intro',
  imports: [RouterLink, IntroContainerComponent, SectionComponent, SubsectionComponent, FeatureComponent, SectionSubstitleComponent],
  templateUrl: './flipper-intro.component.html',
  styleUrl: './flipper-intro.component.scss'
})
export class FlipperIntroComponent {

}
